import { Action } from '../types'
import { LegalType } from '../../types/legal'
import { LegalTypes } from './types'

type LegalAction = Action<LegalTypes, LegalType>

const initialState: LegalType = {
  startDate: undefined,
  endDate: undefined,
  hasNda: undefined,
  isAssistedByPartner: undefined,
  billingCountryId: undefined,
  geographicSegmentationId: undefined,
  signers: [],
  additionalInfo: undefined,
  locationId: null,
  isNew: false,
  salesQueueId: undefined
}

export function legalReducer(
  state = initialState,
  action: LegalAction
): LegalType {
  switch (action.type) {
    case LegalTypes.SAVE_LEGAL:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
